import {Chart} from "chart.js";
let chart = $("#myChart");
if( chart.length > 0) {
    const myChart = new Chart(chart, {
        type: 'line',
        data: {
            labels: JSON.parse(chart.attr("labels")),
            datasets: JSON.parse(chart.attr("data"))
        },
        options: {
            scales: {
                y: {
                    beginAtZero: true
                }
            }
        }
    });
}